// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isPromise = (prom: any): boolean => {
  if (typeof prom === 'object' && typeof prom.then === 'function') {
    return true;
  }

  return false;
};

export const convertCamelCaseToString = (camelCaseText: string): string => {
  const result = camelCaseText.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};
